module.exports = __webpack_public_path__ + "static/img/fotter_logo.e0675aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/fotter_logo.png
// module id = du0J
// module chunks = 1